import { render, staticRenderFns } from "./expertDatabase.vue?vue&type=template&id=427ffa72&scoped=true"
import script from "./expertDatabase.vue?vue&type=script&lang=js"
export * from "./expertDatabase.vue?vue&type=script&lang=js"
import style0 from "./expertDatabase.vue?vue&type=style&index=0&id=427ffa72&prod&lang=css"
import style1 from "./expertDatabase.vue?vue&type=style&index=1&id=427ffa72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ffa72",
  null
  
)

export default component.exports